import {
  resolveActiveWorkspace,
  workspaceHomePath,
  WORKSPACES,
} from "./workspaces";

export const MOBILE_HOME_MAX_WIDTH = 768;

export function isMobileViewport(maxWidth = MOBILE_HOME_MAX_WIDTH) {
  if (typeof window === "undefined") return false;
  if (typeof window.matchMedia === "function") {
    return window.matchMedia(`(max-width:${maxWidth}px)`).matches;
  }
  return window.innerWidth <= maxWidth;
}

/** Default landing path for the active Inssure workspace. */
export function getDefaultHomePath(userData, permissionList = null) {
  const workspace = resolveActiveWorkspace(userData, permissionList);
  if (workspace === WORKSPACES.STUDENT) {
    return workspaceHomePath(workspace);
  }
  if (workspace === WORKSPACES.TRAINER) {
    return "/dashboard";
  }
  return isMobileViewport() ? "/dashboard" : "/";
}
